import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import Reveal from 'react-reveal/Reveal'

class Footer extends Component {
    render() {
        let FooterData = this.props.FooterData;
        return (
            <footer className="new_footer_area bg_color">
                <div className="new_footer_top">
                    <div className="container">
                        <div className="row">
                            {
                                FooterData.CompanyWidget.map(widget => {
                                    return (
                                        <Reveal effect="fadeInUp" key={widget.id}>
                                            <div className="col-lg-3 col-md-6">
                                                <div className="f_widget company_widget wow fadeInLeft"
                                                     data-wow-delay="0.2s">
                                                    <a href="/" className="f-logo"><img
                                                        src={require('../../img/logo.png')} alt=""/></a>
                                                    <div className="widget-wrap">
                                                        <p className="f_400 f_p f_size_15 mb-0 l_height34">
                                                            <span>Email:</span> <a
                                                            href="mailto:backslash.info.help@gmail.com"
                                                            className="f_400">backslash.info.help</a></p>
                                                        <p className="f_400 f_p f_size_15 mb-0 l_height34">
                                                            <span>Phone:</span> <a href="tel:94779321995"
                                                                                   className="f_400">+9477 932 1995</a>
                                                        </p>
                                                    </div>
                                                    <form action="#" className="f_subscribe mailchimp" method="post">
                                                        <input type="text" name="EMAIL" className="form-control memail"
                                                               placeholder="Email"/>
                                                        <button className="btn btn-submit" type="submit"><i
                                                            className="ti-arrow-right"/></button>
                                                    </form>
                                                </div>
                                            </div>
                                        </Reveal>
                                    )
                                })
                            }
                            {
                                FooterData.AboutWidget.map(widget => {
                                    return (
                                        <Reveal effect="fadeInLeft" duration={500} key={widget.id}>
                                            <div className="col-lg-3 col-md-6">
                                                <div className="f_widget about-widget pl_70 wow fadeInLeft"
                                                     data-wow-delay="0.4s">
                                                    <h3 className="f-title f_600 t_color f_size_18">{widget.title}</h3>
                                                    <ul className="list-unstyled f_list">
                                                        {
                                                            widget.menuItems.map(item => {
                                                                return (
                                                                    <li key={item.id}><Link to="/">{item.text}</Link>
                                                                    </li>
                                                                )
                                                            })
                                                        }
                                                    </ul>
                                                </div>
                                            </div>
                                        </Reveal>
                                    )
                                })
                            }
                            {
                                FooterData.SocialLinks.map(widget => {
                                    return (
                                        <Reveal effect="fadeInLeft" duration={500} key={widget.id}>
                                            <div className="col-lg-3 col-md-6">
                                                <div className="f_widget social-widget pl_70 wow fadeInLeft"
                                                     data-wow-delay="0.4s">
                                                    <h3 className="f-title f_600 t_color f_size_18">{widget.title}</h3>
                                                    <div className="f_social_icon">
                                                        {
                                                            widget.menuItems.map(item => {
                                                                return (
                                                                    <a href={item.url} target="_blank"  rel="noopener noreferrer" key={item.id}><i className={item.icon}/></a>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                                <br/>
                                                <div className="f_widget company_widget wow fadeInLeft"
                                                     data-wow-delay="0.2s">
                                                    <center><img src={require('../../img/backslash-logo.png')} alt=""
                                                     style={{"width": "200px"}} /></center>
                                                </div>
                                            </div>
                                        </Reveal>
                                    )
                                })
                            }
                        </div>

                    </div>
                    <div className="footer_bg">
                        <div className="footer_bg_one"/>
                        <div className="footer_bg_two"/>
                    </div>
                </div>
                <div className="footer_bottom">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-sm-7">
                                <p className="mb-0 f_400">{FooterData.copywrite}</p>
                            </div>
                            <div className="col-lg-6 col-sm-5 text-right">
                                <p>Simple. Innovative. Powerful.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        )
    }
}

export default Footer;
